import React from 'react';
import styled from 'styled-components';
import colors from '../../assets/colors';
import { tabletScreen, mobileScreen,desktopScreen } from '../../assets/screens';
import { FontAwesome } from '../Bootstrap';

// eslint-disable-next-line import/no-anonymous-default-export
export default function ({ operator }) {
  const { goToNext, goToPrevious, slides, currentIndex, goToSlide } = operator;

  const captureMap =
    operator.captures instanceof Map ? operator.captures : new Map();

  const isSlideUploaded = (slideIndex) =>
    captureMap.has(slides[slideIndex]?.view);
  const RightArrow = ArrowStyles('right');
  const LeftArrow = ArrowStyles('left');

  return (
    <ArrowGroup>
      <LeftArrow color={colors.blue3} dir="left" onClick={goToPrevious}>
        <FontAwesome className="fa-solid fa-chevron-left" />
      </LeftArrow>

      <ViewGroup>
        <ViewTitle>{slides[currentIndex].view}</ViewTitle>

        <DotsContainerParent>
          <DotsContainerStyles>
            {slides?.map((slide, slideIndex) => {
              const uploaded = isSlideUploaded(slideIndex);
              const isActive = slideIndex === currentIndex;
              return (
                <DotStyle
                  key={slideIndex}
                  type="button"
                  onClick={() => goToSlide(slideIndex)}
                  uploaded={uploaded}
                  isActive={isActive}
                  aria-label={`${slide.view}${uploaded ? ', uploaded' : ''}`}
                  aria-current={isActive ? 'true' : undefined}
                  background={
                    isActive
                      ? colors.blue3
                      : uploaded
                        ? colors.green
                        : colors.grey2
                  }
                  title={`${slide.view}${uploaded ? ' (uploaded)' : ''}`}
                />
              );
            })}
          </DotsContainerStyles>
        </DotsContainerParent>
      </ViewGroup>

      <RightArrow color={colors.blue3} dir="right" onClick={goToNext}>
        <FontAwesome className="fa-solid fa-chevron-right" />
      </RightArrow>
    </ArrowGroup>
  );
}

const ViewGroup = styled('div')`
  position: relative;
  display: flex;
  margin-left: auto;
  margin-right: auto;
  ${'' /* min-width: 50%; */}
  ${desktopScreen(`
  width: 70%;
`)}
  ${tabletScreen(`
  width: 100%;
`)}
${mobileScreen(`
  width: 70%;
`)}

  flex-direction: column;
  align-items: center;

  &.item {
    flex-grow: 1;
  }
  &.dot {
    background: ${colors.blue2};
  }
`;

const ViewTitle = styled('span')`
  color: ${colors.black};
  font-size: 15px;

  &::first-letter {
    text-transform: capitalize;
  }

  &:before {
    content: ${(props) => props.title || ''};
    position: relative;
  }
`;

const ArrowGroup = styled('div')`
  position: relative;
  display: flex;
  width: 80%;
  ${mobileScreen(`
     width: 90%;
  `)}
  align-items: flex-center;
  gap: 4px;
  margin-top: 20px;
  margin-left: auto;
  margin-right: auto;
`;

const ArrowStyles = () => styled('button')`

  flex-shrink: 0;
  font-size: 30px;
  color: #10a9bb;
  display: block;
  z-index: 1;
  cursor: pointer;
  border: none;
  background: transparent;
  padding: 4px 8px;

  & i {
    color: ${(props) => props.color || '#10a9bb'};
  }

  ${tabletScreen(`
      position: relative;
      left: auto;
      right: auto;
      top: auto;
      transform: none;
    `)};
`;

const DotsContainerParent = styled('div')`
  display: flex;
  justify-content: center;
  width: 50%;
  ${mobileScreen(`
    width: 100%;
  `)}
  position: relative;
  z-index: 2;
`;

const DotsContainerStyles = styled('div')`
  display: flex;
  width: 100%;
  ${mobileScreen(`
    width: 90%;
  `)}
  align-items: center;
  min-height: 28px;
  gap: 1px;
`;

const DotStyle = styled('button')`
  all: unset;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  min-width: 0;
  min-height: 28px;
  padding: 4px 0;
  cursor: pointer;
  touch-action: manipulation;

  &::after {
    content: '';
    display: block;
    height: ${(props) => (props.isActive ? 10 : 8)}px;
    width: ${(props) =>
      props.isActive ? '100%' : props.uploaded ? '85%' : '70%'};
    max-width: ${(props) => (props.isActive ? 18 : props.uploaded ? 14 : 10)}px;
    border-radius: 10px;
    background-color: ${(props) => props.background};
    transition: all 0.2s ease;
  }

  &:focus-visible {
    outline: 2px solid ${colors.blue3};
    outline-offset: 1px;
    border-radius: 6px;
  }
`;
